import React from "react";
import { Link } from "react-router-dom";
import { Vote, Mic, Download, Users, Megaphone, ArrowRight } from "lucide-react";
import { useAuth } from "@/lib/auth-context";
import PageBlocks from "@/components/site/PageBlocks";
import PageHeader from "@/components/site/PageHeader";

const ACTIONS = [
  { to: "/carte", label: "Créer ou rejoindre une action", desc: "Lance ou rejoins une mobilisation (rassemblement, marche, blocage…). Création réservée aux élèves connecté·es.", Icon: Megaphone, color: "bg-cef-pink text-white" },
  { to: "/carte#groupes", label: "Rejoindre un groupe local", desc: "Trouve l'antenne CEF de ta province et suis-la sur Instagram.", Icon: Users, color: "bg-cef-green" },
  { to: "/donner-mon-avis", label: "Donner mon avis", desc: "Vote, réponds aux sondages, propose tes idées via la boîte à idées.", Icon: Vote, color: "bg-cef-yellow" },
  { to: "/temoignages", label: "Témoigner", desc: "Partage ton expérience d'élève, anonymement ou non.", Icon: Mic, color: "bg-cef-blue text-white" },
  { to: "/actions", label: "Pack Action", desc: "Kits, guides PDF, ressources pour mobiliser ton école.", Icon: Download, color: "bg-white" },
  { to: "/rejoindre", label: "Devenir membre du CEF", desc: "Rejoins l'équipe officielle des élèves francophones.", Icon: Users, color: "bg-black text-white" },
];

export default function Agir() {
  const { user: _user } = useAuth();
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <span className="chip bg-cef-pink text-white">L'action, c'est ici</span>
      <div className="mt-3">
        <PageHeader slug="agir" fallbackTitle="Passe à l'[action](yellow)" fallbackSubtitle="Mobilise ton école, vote sur les réformes, partage ton histoire. Tout est possible — fait par et pour les élèves." />
      </div>

      <PageBlocks slug="agir" className="mt-6" />

      <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="agir-grid">
        {ACTIONS.map(({ to, label, desc, Icon, color }) => (
          <Link key={to} to={to} className={`neo-card p-6 block group ${color}`} data-testid={`agir-${to}`}>
            <Icon className="w-8 h-8" strokeWidth={2.5} />
            <h3 className="mt-3 font-display font-black text-xl tracking-tight">{label}</h3>
            <p className="mt-2 text-sm opacity-90">{desc}</p>
            <div className="mt-4 inline-flex items-center gap-1 text-sm font-bold opacity-80 group-hover:translate-x-1 transition"><ArrowRight className="w-4 h-4" /> Y aller</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
